// eslint-disable-next-line @typescript-eslint/naming-convention
let _isAnonymous = false;
// eslint-disable-next-line @typescript-eslint/naming-convention
let _token: string | null = null;

export const anonymousSessionState = {
  get isAnonymous(): boolean {
    return _isAnonymous;
  },
  get token(): string | null {
    return _token;
  },
  setSession(token: string): void {
    _isAnonymous = true;
    _token = token;
  },
  clearSession(): void {
    _isAnonymous = false;
    _token = null;
  },
};
